import {Component, Input, OnChanges, SimpleChanges, SimpleChange} from '@angular/core';
import {MarketingDetailsApiResponseInterface, MarketingDetailColumnItemInterface, MarketingDetailColumnGroupInterface} from '../../../models/marketing-detail.model';

@Component({
  selector: 'app-exclusions',
  templateUrl: './exclusions.component.html',
  styleUrls: ['./exclusions.component.scss'],
  standalone: false
})

export class ExclusionsComponent implements OnChanges {
  @Input() public details: MarketingDetailsApiResponseInterface | null = null;

  public exclusions: string[] = [];

  private readonly _defaultExclusions: string[] = [
    "The following services are not included in the plan and you are responsible for payment of the dentist's normal fees for these services:",
    'Services provided by a dentist who is not participating in the plan.',
    'Procedures deemed not reasonably necessary or not customarily performed, including, but not limited to services that have a poor prognosis and duplicate prosthetic devices or appliances, as determined by the dentist.',
    'Anesthesiologist services.',
    'Treatment of jaw fractures or dislocations, congenital or developmental malformations, malignancies, cysts or neoplasms, or Temporomandibular Joint Syndrome (TMJ).',
    'Courses of treatment which began prior to the effective date of your plan and/or expenses incurred after termination of your plan.',
    "Any dental disease, defect or injury that arises out of any occupational incident or exposure for which you can receive benefits under applicable workers' compensation law.",
    "Services of a specialist, including specialty X-rays such as a CBCT's.",
    'Cleaning types are determined by the diagnosis of the General Practitioner. Prophylaxis benefits are excluded in the presence of periodontal disease'
  ];

  public ngOnChanges(changes: SimpleChanges): void {
    const detailsChange: SimpleChange = changes['details'];
    if (detailsChange) {
      this._updateExclusions();
    }
  }

  private _updateExclusions(): void {
    const exclusions = this.details?.salesPlanMarketingDetails?.exclusion;
    if (exclusions && exclusions.length > 0) {
      const dynamicExclusions: string[] = exclusions
        .flatMap((group: MarketingDetailColumnGroupInterface) => group.value)
        .map((item: MarketingDetailColumnItemInterface) => item.column1 || '')
        .filter((text: string) => text !== '');
      this.exclusions = [...this._defaultExclusions, ...dynamicExclusions];
    } else {
      this.exclusions = this._defaultExclusions;
    }
  }
}
